:host{min-width:0;display:block;border:1px;margin:0 7px}
/*# sourceMappingURL=column.component.css.map */
